module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "enter-class": "fade-in-enter",
      "enter-active-class": "fade-in-active",
      "leave-class": "fade-out-enter",
      "leave-active-class": "fade-out-active"
    }
  }, [(_vm.isShow) ? _c('div', {
    staticClass: "dialog-cover",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "dialog-content",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doSomething($event)
      }
    }
  }, [_c('div', {
    staticClass: "dialog_head"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog_main"
  }, [_vm._t("main", function() {
    return [_vm._v("弹窗内容")]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('button', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "ok openApp",
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确定")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f90fef22!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog.vue
// module id = 872
// module chunks = 2